import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { checkBox, Form } from "trader.ts/ui.forms";
import { formulaid, instrumentid } from "../../../sql/classy/types";
import * as style from "../../../styles/style.css.classes";
import { checkboxesField } from "../../client/checkboxesfield";
import { renderSaveButton } from "../../client/savebutton";
import { formulaType } from "../../parsing_from_ur";
import * as routes from "../../routes";

export function render(opts: {
  instruments: {
    id: instrumentid;
    description: string;
    showonpublicplanning: boolean;
    private_waitinglist_active: boolean;
  }[];
  formulas: {
    id: formulaid;
    description: string;
    type_: formulaType;
    group_waitinglist_active: boolean;
    showonpublicplanning: boolean;
    instruments: instrumentid[];
  }[];
  allowPrivateTeacherSelection: boolean;
}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("instrumentsToShow", [], async () => {
      const values = opts.instruments;
      return checkboxesField({
        values,
        initial: values.filter((instr) => instr.showonpublicplanning),
        show: (i) => i.description,
        addAllOption: true,
        addNoFilterOption: false,
        label: "Welke instrumenten mogen getoond worden in de publieke inschrijven? Dit telt zowel voor privé- als voor groepslessen.",
      });
    })
    .addField("allowPrivateTeacherSelection", [], () =>
      checkBox({
        initialVal: opts.allowPrivateTeacherSelection,
        class: style.checkbox + style.input_like,
        label: "Student mogen een voorkeursdocent kiezen tijdens het inschrijven voor een privéles.",
      }),
    )
    .addField("showPrivateFormulasOnPublicPlanning", [], async () => {
      const values = opts.formulas.filter((f) => f.type_.tag === "Private");
      return checkboxesField({
        values,
        initial: values.filter((f) => f.showonpublicplanning),
        show: (i) => i.description,
        addAllOption: true,
        addNoFilterOption: false,
        label: "Welke formules mag een student kiezen tijdens het inschrijven voor een privéles?",
      });
    })
    .addField("instrumentsToActivatePrivateWaitinglist", [], async () => {
      const values = opts.instruments.filter((instr) =>
        opts.formulas.some(
          (f) =>
            f.type_.tag === "Private" &&
            f.instruments.some((id) => instr.id === id),
        ),
      );
      return checkboxesField({
        values,
        initial: values.filter((instr) => instr.private_waitinglist_active),
        show: (i) => i.description,
        addAllOption: true,
        addNoFilterOption: false,
        label: "Voor welke instrumenten wil je een wachtlijst bijhouden voor privélessen?",
      });
    })
    .addField("formulasToActiveGroupWaitinglist", [], async () => {
      const values = opts.formulas.filter((f) => f.type_.tag === "Group");
      return checkboxesField({
        values,
        initial: values.filter((instr) => instr.group_waitinglist_active),
        show: (i) => i.description,
        addAllOption: true,
        addNoFilterOption: false,
        label: "Voor welke formules wil je een wachtlijst bijhouden voor groepslessen?",
      });
    })
    .build({
      render: (fields) => {
        const panelStyle = ` background-color: var(--grey-100); border: none; `;
        return (
          <div>
            <section className={style.panel} style={panelStyle}>
              {fields.instrumentsToShow()}
            </section>
            {fields.allowPrivateTeacherSelection()}
            <section className={style.panel} style={panelStyle}>
              {fields.showPrivateFormulasOnPublicPlanning()}
            </section>
            <section className={style.panel} style={panelStyle}>
              {fields.instrumentsToActivatePrivateWaitinglist()}
            </section>
            <section className={style.panel} style={panelStyle}>
              {fields.formulasToActiveGroupWaitinglist()}
            </section>
          </div>
        );
      },
    });

  return (
    <div>
      <section>{form.render()}</section>
      <section style="text-align: right">
        {renderSaveButton({
          formS: form.s,
          save: (vals) => {
            return rpc(routes.savePublicEnrollmentsConfigSpec, undefined, vals);
          },
          reload: true,
        })}
      </section>
    </div>
  );
}
